












import { defineComponent, ref } from "@vue/composition-api";
import providers from "@/lib/api";
import { executeAndUpdate } from "@/lib/executeAndUpdate";
import config from "@/config";
import BaseSwitch from "@/components/BaseSwitch";
import useAutoPostingToX from "@/features/twitterAutoPosting/hooks/useAutoPostingToX";

export default defineComponent({
  name: "AutoPostingToXSetting",
  components: { BaseSwitch },
  setup() {
    const { settings, allowSetupAutoPostingSettings, fetchSettings } = useAutoPostingToX();
    const enabled = ref(false);
    const processing = ref(false);

    const enableAutoPosting = async () => {
      const success = await executeAndUpdate(
        () => providers.TwitterAutoPostingProvider.loginGetAuthUrl({ callbackUrl: config.twitterCallbackUrl }),
        query =>
          providers.TwitterAutoPostingProvider.login({
            data: { code: (Array.isArray(query.code) ? query.code[0] : query.code) || "" },
          })
      );
      enabled.value = !!success;
    };

    const disableAutoPosting = async () => {
      const success = await providers.TwitterAutoPostingProvider.revokeToken();
      enabled.value = !success;
    };

    const onToggle = async (value: boolean) => {
      if (!allowSetupAutoPostingSettings.value) return;
      if (processing.value || enabled.value === value) {
        return;
      }

      const prevValue = enabled.value;
      enabled.value = value;
      processing.value = true;

      try {
        if (!value) return disableAutoPosting();
        await enableAutoPosting();
      } catch {
        enabled.value = prevValue;
      } finally {
        processing.value = false;
      }
    };

    const getData = async () => {
      await fetchSettings();
      if (settings.value) {
        enabled.value = settings.value.enabled;
      }
    };

    getData();

    return {
      allowAutoPosting: allowSetupAutoPostingSettings,
      enabled,
      onToggle,
    };
  },
});
